import { getLocalStorage } from './global';

export const getUserToken = () => {
  const token = getLocalStorage().getItem(`user_token`);
  if (token === null) {
    return null;
  }
  return JSON.parse(token);
};

export const getUserRefreshToken = () => {
  const refreshToken = getLocalStorage().getItem(`user_refresh_token`);
  if (refreshToken === null) {
    return null;
  }
  return JSON.parse(refreshToken);
};

export const setUserToken = (token: string) => {
  getLocalStorage().setItem(`user_token`, JSON.stringify(token));
};

export const setUserRefreshToken = (refreshToken: string) => {
  getLocalStorage().setItem(`user_refresh_token`, JSON.stringify(refreshToken));
};

export const removeUserToken = () => {
  getLocalStorage().removeItem(`user_token`);
};

export const removeUserRefreshToken = () => {
  getLocalStorage().removeItem(`user_refresh_token`);
};

export const setAppToken = (token: string) => {
  getLocalStorage().setItem(`app_token`, JSON.stringify(token));
};

export const getAppToken = () => {
  const token = getLocalStorage().getItem(`app_token`);
  if (token === null) {
    return null;
  }
  return token;
};
